/**
 * AI Tax Advisor API Client — Chunk 181
 *
 * Typed wrapper around the existing /ai-commentary/:userId/query endpoint
 * with tax-specific payload helpers.
 *
 * Tax-intent keywords that trigger augmented context on the backend:
 * sell, harvest, tax, capital gains, short-term, long-term, wash sale, hold until
 */

import apiClient from './client';

export interface TaxAdvisorQueryPayload {
  /** The user's natural-language tax question */
  query: string;
}

export interface TaxAdvisorResponse {
  /** The AI-generated answer (may include tax lot details, estimated tax, holding period) */
  answer: string;
  /** Number of queries used today out of the 20/day Pro+ limit */
  queriesUsedToday: number;
  /** Number of queries remaining today */
  queriesRemainingToday: number;
}

/**
 * Send a tax-specific query to the AI commentary endpoint.
 * The backend automatically detects tax-intent keywords and augments the
 * GPT-4o-mini context with cost basis, holding periods, wash-sale risk,
 * harvest opportunities, and jurisdiction settings.
 */
export async function queryTaxAdvisor(
  userId: string,
  query: string,
): Promise<TaxAdvisorResponse> {
  const { data } = await apiClient.post<TaxAdvisorResponse>(
    `/analytics/ai-commentary/${userId}/query`,
    { query } satisfies TaxAdvisorQueryPayload,
  );
  return data;
}

/** Pre-built tax question chips shown in the quick-reply row */
export const TAX_QUICK_QUESTIONS: string[] = [
  'Should I harvest my ETH loss now?',
  "What's my estimated tax bill this year?",
  'Which positions are closest to long-term treatment?',
  'Show me wash-sale risks',
];
